import { DataTableRow as RWMC, DataTableRowProps as RWMCProps } from "@rmwc/data-table"
import { HTMLAttributes, useCallback } from "react"
import omit from "lodash/omit"
import { callCSSFn, CSS, CSSFn, styled, StyleProps } from "../../styles"

export type DataTableFooterRowProps = RWMCProps &
  HTMLAttributes<HTMLTableRowElement> & {
    index?: number
    css?: CSSFn
    action?: (rowIndex: number) => void
  }
const Component = ({ index, action, ...props }: DataTableFooterRowProps) => {
  const onClick = useCallback(() => {
    if (!action || index === undefined) return
    action(index)
  }, [action, index])
  return <RWMC onClick={onClick} {...omit(props, `css`)} />
}
Component.defaultProps = {
  index: undefined,
  css: undefined,
  action: undefined,
}

export const DataTableFooterRow = styled(Component)(
  (props: StyleProps & DataTableFooterRowProps): CSS => ({
    borderTop: `1px solid ${props.theme.palette.grey.dark}`,
    cursor: props.action ? `pointer` : `default`,
    ...callCSSFn(props),
  })
)
